import { render } from "./styling_table.vue?vue&type=template&id=193b13a8"
import script from "./styling_table.vue?vue&type=script&lang=js"
export * from "./styling_table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__